export var isNullish = function (item) {
    // Using "null" value intentionally for validation
    // eslint-disable-next-line no-null/no-null
    return item === undefined || item === null;
};
//# sourceMappingURL=object.js.map